// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"278":"727973242bb33abd","487":"727973242bb33abd","1976":"727973242bb33abd","4022":"727973242bb33abd","4972":"727973242bb33abd","4978":"727973242bb33abd","6042":"727973242bb33abd","8640":"727973242bb33abd"}[chunkId] + ".css";
};